import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />
        <main id="main" role="main">
          <div
            id="shopify-section-template--17866866557012__hero_aw3P7g"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866557012__hero_aw3P7g"
              data-section-id="template--17866866557012__hero_aw3P7g"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "356.275px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_FcTjmh"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <div
                          className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                          style={{
                            paddingBottom: "23.7012987012987%",
                            backgroundImage: "url(/main/about1.jpg)",
                          }}
                        >
                          <img
                            src="/main/about1.jpg"
                            alt=""
                            width={1920}
                            height={455}
                            loading="eager"
                            className="Slideshow__Image"
                            data-optimux="1.2"
                            sizes="auto"
                            style={{ opacity: 1 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866557012__hero_aw3P7g-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n      #section-template--17866866557012__hero_aw3P7g .Heading,\n      #section-template--17866866557012__hero_aw3P7g .flickity-page-dots {\n        color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_aw3P7g .Button {\n        color: #363636;\n        border-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_aw3P7g .Button::before {\n        background-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_aw3P7g .Underlined {\n        color: #363636;\n        border-color: #363636;\n      }\n    ",
              }}
            />
          </div>
          <div
            id="shopify-section-template--17866866557012__media_grid_Ahzetb"
            className="shopify-section shopify-section__media-grid shopify-section--bordered"
          >
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n      .media-grid__items--template--17866866557012__media_grid_Ahzetb {\n        display: grid;\n        grid-column-gap: var(--media-grid-col-gap, 0px);\n        grid-row-gap: var(--media-grid-row-gap, 0px);\n        grid-template-columns: repeat(var(--media-grid-cols, 1), 1fr);\n      }\n\n      @media (min-width: 768px) {\n        .media-grid__items--template--17866866557012__media_grid_Ahzetb {\n          --media-grid-col-gap: 0px;\n          --media-grid-row-gap: 0px;\n          --media-grid-cols: 2;\n        }\n      }\n\n      @media (min-width: 1140px) {\n        .media-grid__items--template--17866866557012__media_grid_Ahzetb {\n          --media-grid-col-gap: 0px;\n          --media-grid-row-gap: 0px;\n          --media-grid-cols: 2;\n        }\n      }\n    ",
              }}
            />
            <section
              className="Section--spacingNone"
              id="section-template--17866866557012__media_grid_Ahzetb"
              data-section-type="media-grid"
              data-section-id="template--17866866557012__media_grid_Ahzetb"
            >
              <div
                className="media-grid__items media-grid__items--template--17866866557012__media_grid_Ahzetb"
                style={{ paddingBottom: 0, paddingTop: 0 }}
              >
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/about2-1.webp"
                      alt=""
                      width={1080}
                      height={500}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/about2-2.webp"
                      alt=""
                      width={1080}
                      height={476}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/about2-3.webp"
                      alt=""
                      width={1080}
                      height={471}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
                <Link
                  onClick={toTop}
                  className="media-grid__item"
                  to="/shop"
                  style={{ minHeight: "100%", display: "block" }}
                >
                  <picture>
                    <img
                      src="/main/about2-4.webp"
                      alt=""
                      width={1080}
                      height={471}
                      loading="lazy"
                      aria-hidden="true"
                      role="presentation"
                      style={{ minHeight: "100%", objectFit: "cover" }}
                    />
                  </picture>
                </Link>
              </div>
            </section>
          </div>
          <div
            id="shopify-section-template--17866866557012__hero_rBVxaA"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866557012__hero_rBVxaA"
              data-section-id="template--17866866557012__hero_rBVxaA"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "348.237px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_jFfTBc"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <div
                          className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                          style={{
                            paddingBottom: "23.166666666666668%",
                            backgroundImage: "url(/main/about2-5.webp)",
                          }}
                        >
                          <img
                            className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                            data-optimumx="1.2"
                            data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                            data-sizes="auto"
                            alt=""
                            sizes="1503px"
                            style={{ opacity: 1 }}
                            src="/main/about2-5.webp"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866557012__hero_rBVxaA-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n      #section-template--17866866557012__hero_rBVxaA .Heading,\n      #section-template--17866866557012__hero_rBVxaA .flickity-page-dots {\n        color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_rBVxaA .Button {\n        color: #363636;\n        border-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_rBVxaA .Button::before {\n        background-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_rBVxaA .Underlined {\n        color: #363636;\n        border-color: #363636;\n      }\n    ",
              }}
            />
          </div>
          <div
            id="shopify-section-template--17866866557012__hero_BHyGHg"
            className="shopify-section shopify-section--hero"
          >
            <section
              id="section-template--17866866557012__hero_BHyGHg"
              data-section-id="template--17866866557012__hero_BHyGHg"
              data-section-type="slideshow"
            >
              <div className="Slideshow ">
                <div className="Slideshow__Carousel Carousel Carousel--insideDots flickity-enabled">
                  <div
                    className="flickity-viewport"
                    style={{ height: "113.637px" }}
                  >
                    <div
                      className="flickity-slider"
                      style={{ left: 0, transform: "translateX(0%)" }}
                    >
                      <div
                        id="Slideimage_yE8xAN"
                        className="Slideshow__Slide Carousel__Cell is-selected"
                        style={{
                          visibility: "inherit",
                          position: "absolute",
                          left: "0%",
                          opacity: 1,
                        }}
                        data-slide-index={0}
                      >
                        <Link onClick={toTop} to="/shop">
                          <div
                            className="Slideshow__ImageContainer  AspectRatio AspectRatio--withFallback hidden-phone"
                            style={{
                              paddingBottom: "7.5602968460111315%",
                              backgroundImage: "url(/main/about2-6.webp)",
                            }}
                          >
                            <img
                              className="Slideshow__Image hide-no-js lazyautosizes Image--lazyLoaded"
                              data-optimumx="1.2"
                              data-widths="[400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200]"
                              data-sizes="auto"
                              alt=""
                              sizes="1503px"
                              style={{ opacity: 1 }}
                              src="/main/about2-6.webp"
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                id="section-template--17866866557012__hero_BHyGHg-end"
                className="Anchor"
              />
            </section>
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n      #section-template--17866866557012__hero_BHyGHg .Heading,\n      #section-template--17866866557012__hero_BHyGHg .flickity-page-dots {\n        color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_BHyGHg .Button {\n        color: #363636;\n        border-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_BHyGHg .Button::before {\n        background-color: #ffffff;\n      }\n\n      #section-template--17866866557012__hero_BHyGHg .Underlined {\n        color: #363636;\n        border-color: #363636;\n      }\n    ",
              }}
            />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default About;
